import ProductoList from './ProductoList'
export {ProductoList}
export default ProductoList
